@if (pageReady) {
  <main class="gs-page">
    <!-- <app-page-header [headerData]="pageHeader"></app-page-header> -->
    <div class="advantage-headline-container">
      <div class="advantage-headline-content">
        <div class="advantage-content-left">
          <h1 class="headline" [innerHTML]="sanitizedHeaderText"></h1>
          <p class="advantage-description" [innerHTML]="sanitizedSubHeaderText"></p>
        </div>
        <div class="advantage-image-info">
          <img
            class="advantage-img-desktop"
            [src]="pageLabels.bannerImageDesktop"
            [alt]="pageLabels.bannerImageAltText"
          />
          <img
            class="advantage-img-mobile"
            [src]="pageLabels.bannerImageMobile"
            [alt]="pageLabels.bannerImageAltText"
          />
        </div>
      </div>
    </div>
    <div class="gradient-rectangle" data-cy="gradient-rectangle"></div>
    <div class="gs-page-inner">
      <div class="advantage-coupon-container">
        <section class="gs-content-container">
          <div class="iframe-container">
            <iframe
              id="directory-iframe"
              title="Gas South Advantage Coupons"
              src="https://promodeals.app/IoWwLQgkOv/"
              (load)="onIframeLoad()"
              (error)="onIframeError()"
              width="100%"
              height="100%"
              margin="0"
              padding="0"
              seamless="seamless"
              scrolling="yes"
              style="border: 0px; width: 100%; height: 100vh"
            ></iframe>
          </div>
          <p class="disclaimer-text" [innerHTML]="sanitizedDisclaimerText"></p>
          @if (isBrowser && isLoggedIn === false) {
            <div class="advantage-cta-container">
              <div class="advantage-cta-content">
                <div class="advantage-cta-content-left">
                  <div class="headline-cta" [innerHTML]="sanitizedCtaHeaderText"></div>
                  <p class="advantage-cta-description">{{ pageLabels.unauthenticatedCtaSubheaderText }}</p>
                  <div class="cta-container-cta">
                    <div class="advantage-cta-button-container">
                      <a
                        class=""
                        [href]="pageLabels.unauthenticatedCtaUrl"
                        [innerHTML]="pageLabels.unauthenticatedCtaLinkText"
                      >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="advantage-cta-image-info">
                  <img
                    class="advantage-cta-img-desktop"
                    [src]="pageLabels.unauthenticatedCtaImage"
                    [alt]="pageLabels.unauthenticatedCtaAltImageText"
                  />
                </div>
              </div>
            </div>
          }
          <!-- keeping this here for future use when we have the authenticated experience ready to be displayed -->
          <!-- @else {
            <div class="advantage-cta-container">
              <div class="advantage-cta-content">
                <div class="advantage-cta-content-left">
                  <div class="headline-cta" [innerHTML]="sanitizedAuthCtaHeaderText"></div>
                  <p class="advantage-cta-description">{{ pageLabels.authenticatedCtaSubheaderText }}</p>
                  <div class="cta-container-cta">
                    <div class="advantage-cta-button-container">
                      <a
                        class=""
                        [href]="pageLabels.authenticatedCtaUrl"
                        [innerHTML]="pageLabels.authenticatedCtaLinkText"
                      >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="advantage-cta-image-info">
                  <img
                    class="advantage-cta-img-desktop"
                    [src]="pageLabels.authenticatedCtaImage"
                    [alt]="pageLabels.authenticatedCtaAltImageText"
                  />
                </div>
              </div>
            </div>
          } -->
        </section>
      </div>
    </div>
    <div class="perks-container">
      <h3 class="perks-title">{{ pageLabels.perksSectionTitle }}</h3>
      <p class="perks-sub-title">{{ pageLabels.perksSectionSubTitle }}</p>
      <div class="perks">
        @for (perk of perks; track perk) {
          <div class="perk">
            <img class="perk-image" [src]="perk.image" [alt]="perk.imageAltText" />
            <h4 class="perk-title">{{ perk.title }}</h4>
            <p class="perk-text">{{ perk.paragraph }}</p>
            <a class="perk-link" [href]="perk.link" target="_blank" aria-label="(opens in new tab)"
              >{{ perk.linkText }} <i class="fa-solid fa-angle-right link-arrow" aria-hidden="true"></i
            ></a>
          </div>
        }
      </div>
    </div>
  </main>
}
